import React from 'react';
import { IExtensionProps } from '../files.interface';

interface dict {
  [index: string]: string;
}
const extensionColor: dict = {
  pdf: '#F15642',
  rtf: '#F15642',
  doc: '#50BEE8',
  docx: '#50BEE8',
  xls: '#84BD5A',
  xlsx: '#84BD5A',
  csv: '#84BD5A',
  zip: '#84BD5A',
  rar: '#84BD5A',
  ppt: '#F7B84E',
  pptx: '#F7B84E',
  '7z': '#576D7E',
};

const ExtIcon = ({ extension = '', size = 20, style }: IExtensionProps) => (
  <svg style={style} width={size} height={size} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5918 0C3.83555 0 3.2168 0.61875 3.2168 1.375V20.625C3.2168 21.3813 3.83555
       22 4.5918 22H18.3418C19.098 22 19.7168 21.3813 19.7168 20.625V5.5L14.2168 0H4.5918Z"
      fill="#E2E5E7"
    />
    <path d="M15.5918 5.5H19.7168L14.2168 0V4.125C14.2168 4.88125 14.8355 5.5 15.5918 5.5Z" fill="#B0B7BD" />
    <path d="M19.7168 9.625L15.5918 5.5H19.7168V9.625Z" fill="#CAD1D8" />
    <path
      d="M16.9668 17.875C16.9668 18.2531 16.6574 18.5625 16.2793 18.5625H1.1543C0.776172
       18.5625 0.466797 18.2531 0.466797 17.875V11C0.466797 10.6219 0.776172 10.3125 1.1543
        10.3125H16.2793C16.6574 10.3125 16.9668 10.6219 16.9668 11V17.875Z"
      fill={extensionColor[extension] || '#50BEE8'}
    />
    <text x={extension && extension.length === 3 ? 2 : 1.5} y="16.5" fontFamily="Roboto" fontSize="6" fill="white">
      {extension.toUpperCase()}
    </text>
    <path
      d="M16.2793 18.5625H3.2168V19.25H16.2793C16.6574 19.25 16.9668
       18.9406 16.9668 18.5625V17.875C16.9668 18.2531 16.6574 18.5625 16.2793 18.5625Z"
      fill="#CAD1D8"
    />
  </svg>
);

export default ExtIcon;
